import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { API_URL, LOCATION_ID } from "..";

const PurchaseOrderListLayer = ({ ordersData = [] }) => {

  const location_id = LOCATION_ID;
  const tableRef = useRef(null);
  const history = useNavigate();

  const handleConvertToBill = async (id) => {
      // if (!window.confirm("Are you sure you want to convert this Purchase Order into a Bill?")) return;
      try {
        const res = await fetch(`${API_URL}/api/purchase-orders/convertobill/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      location_id: location_id, // <-- your location id here
    }),
  });
  
        const data = await res.json();
        if (res.ok) {
          alert("Purchase Bill created successfully!");
           window.location.reload();
          // window.location.href = `/view-purchase-bill/${data.bill.id}`;
        } else {
          alert(data.message || "Failed to create bill from purchase order");
        }
      } catch (err) {
        alert("Error: " + err.message);
      }
    };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Purchase Order?")) return;
    try {
      const res = await fetch(`${API_URL}/api/purchase-orders/delete/${id}`, { method: "DELETE" });
      if (res.ok) window.location.reload();
    } catch (err) {
      alert("Error deleting order: " + err.message);
    }
  };

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#dataTable")) {
      $("#dataTable").DataTable().destroy(true);
    }

    tableRef.current = $("#dataTable").DataTable({
      data: ordersData,
      responsive: true,
      pageLength: 10,
      order: [[0, 'desc']],
      columns: [
         {
      data: null,
      title: "#",
      render: (data, type, row, meta) => {
        return meta.settings.fnRecordsDisplay() - meta.row - meta.settings._iDisplayStart;
      }
    },
        { data: "po_number", title: "PO Number",
           render: (bill_number, type, row) => {
    return `<a href="/view-po/${row.id}" class="text-primary">${bill_number}</a>`;
  }
         },
        { data: "date", title: "Date" },
        {
          data: "Supplier",
          title: "Supplier",
          render: (supplier) => supplier?.name || "N/A",
        },
        { data: "status", title: "Status" },
        {
          data: "total_amount",
          title: "Total Amount",
          render: (data) => `Rs. ${parseFloat(data).toLocaleString()}`,
        },
        {
          data: null,
          title: "Actions",
          orderable: false,
          render: (data, type, row) => `
            <div class="dropdown">
              <button class="dropdown-toggle" data-bs-toggle="dropdown"><i class="ph ph-list"></i></button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View</a></li>
                <li><a class="dropdown-item convert-btn" data-id="${row.id}"><i class="ph ph-eye"></i> Convert to Bill</a></li>
                <li><a class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete</a></li>
              </ul>
            </div>
          `,
        },
      ],
    });

    $("#dataTable tbody").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      history(`/view-po/${id}`);
    });

    $("#dataTable tbody").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      handleDelete(id);
    });
    $("#dataTable tbody").on("click", ".convert-btn", function () {
      const id = $(this).data("id");
      handleConvertToBill(id);
    });

    return () => {
      if ($.fn.DataTable.isDataTable("#dataTable")) $("#dataTable").DataTable().destroy(true);
    };
  }, [ordersData]);

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Purchase Orders</h5>
          <div className="col-md-6 text-end">
            <Link className="btn btn-info" to="/add-po">Add New</Link>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="dataTable"></table>
      </div>
    </div>
  );
};

export default PurchaseOrderListLayer;
